import {resources} from "../resources";
import {classNames} from "./classNames";
import {Icon} from "./controls/Icon";
import style from "./LockerView.module.css";
import {ChildrenProps, ClassProps} from "./types";

export enum LockerState {
	Open = "Open",
	Closed = "Closed",
	Released = "Released",
	Offline = "Offline",
}

type LockerViewProps = {
	label?: string;
	inactive?: boolean;
	lockerState?: LockerState;
	number: string;
};

export const LockerView = ({label, number, inactive, lockerState}: LockerViewProps) => (
	<div class={classNames(style.box, inactive && style.inactive)}>
		{label && (
			<div class={style.boxLabel}>
				{label}
			</div>
		)}
		<div class={style.boxNumber}>
			{number}
		</div>
		{lockerState == LockerState.Open && (
			<LockerStateView>
				<StateIcon class={style.stateOpen}>error</StateIcon>
				<LockIcon>lock_open</LockIcon>
			</LockerStateView>
		)}
		{lockerState == LockerState.Closed && (
			<LockerStateView>
				<StateIcon class={style.stateClosed}>check_circle</StateIcon>
				<LockIcon>lock</LockIcon>
			</LockerStateView>
		)}
		{lockerState == LockerState.Released && (
			<LockerStateView>
				<StateIcon class={style.stateReleased}>cancel</StateIcon>
				<div class={style.releasedBar}>
					{resources.strings.Released}
				</div>
			</LockerStateView>
		)}
		{lockerState == LockerState.Offline && (
			<LockerStateView>
				<StateIcon class={style.stateUnknown}>help</StateIcon>
			</LockerStateView>
		)}
	</div>
);

export const LockerStateView = ({children}: ChildrenProps) => (
	<div class={style.lockerState}>
		{children}
	</div>
);

export const StateIcon = (props: ChildrenProps & ClassProps) => (
	<div class={classNames(style.stateIcon, props.class)}>
		<Icon>{props.children}</Icon>
	</div>
);

export const LockIcon = (props: ChildrenProps) => (
	<div class={classNames(style.lockIcon)}>
		<Icon>{props.children}</Icon>
	</div>
);
